import './styles.scss';

import React from 'react';

import CustomPDFViewer from './CustomPDFViewer';

interface Props {
  title?: string;
  showModal: boolean;
  closeModal: () => void;
  url: string;
  initalProgress?: number;
  onProgress?: (progress: number, duration: number) => void;
}

const PdfViewer: React.FC<Props> = ({
  showModal,
  closeModal,
  url,
  onProgress,
}) => {
  if (!showModal) {
    return null;
  }

  return (
    <CustomPDFViewer
      source={url}
      onPageChange={(pageNumber, totalPages) => {
        if (onProgress) {
          onProgress(pageNumber, totalPages);
        }
      }}
      onFullscreenChange={() => {}}
      isFullscreen={showModal}
      onToggleFullscreen={closeModal}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 10000,
      }}
    />
  );
};

export default React.memo(PdfViewer);
